import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { CommunityLinksStrategyService } from '../../../../services/strategies';
import { withLoadingState } from '../../../../utils/observable.utils';
import { CommunityLinksComponent } from '../../community-links.component';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-group-community-links',
  templateUrl: './group-community-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommunityLinksComponent],
  host: {
    '[style.display]': 'hasLinks() ? "contents" : "none"',
  },
})
export class GroupCommunityLinksComponent {
  groupId = input<string | null>(null);

  private strategyService = inject(CommunityLinksStrategyService);
  private strategy = this.strategyService.getStrategy('group');

  private groupId$ = toObservable(this.groupId).pipe(filter(id => !!id));

  private linksState$ = this.groupId$.pipe(
    switchMap(groupId => withLoadingState(this.strategy.loadLinks(groupId), []))
  );

  private state = toSignal(this.linksState$, {
    initialValue: { data: [], loading: true },
  });

  links = computed(() => this.state().data);
  isLoading = computed(() => this.state().loading);
  hasLinks = computed(() => this.state().loading || this.state().data.length > 0);
}
